enum CommandQueueState {
  Idle,
  Processing,
}

interface QueueStateEvent {
  source: 'perfectpost';
  type: 'queue_state';
  payload: {
    state: CommandQueueState;
    commandStack: string[];
    currentCommandId?: string;
  };
}

function isQueueStateEvent(object: unknown): object is QueueStateEvent {
  return (
    object !== undefined &&
    object !== null &&
    typeof object === 'object' &&
    'source' in object &&
    object?.source !== undefined &&
    object.source === 'perfectpost' &&
    'type' in object &&
    object?.type !== undefined &&
    object.type === 'queue_state' &&
    'payload' in object &&
    object?.payload !== undefined &&
    object.payload !== null &&
    typeof object.payload === 'object' &&
    'state' in object.payload &&
    object.payload?.state !== undefined &&
    'commandStack' in object.payload &&
    object.payload?.commandStack !== undefined
  );
}

export {CommandQueueState, type QueueStateEvent, isQueueStateEvent};
